import { Routes } from '@angular/router';
import { AuthGuard } from './services/guards/auth.guard';
import { PagesComponent } from './pages/pages.component';
import { LoginComponent } from './pages/login/login.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { NoAuthGuard } from './services/guards/noauth.guard';

export const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    loadChildren: () => import('./pages/pages.routes'),
    pathMatch: 'prefix',
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      meta: {
        title: 'Login | Welcome to WMS PEZA',
      },
    },
    canActivate: [NoAuthGuard],
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: {
      meta: {
        title: 'Privacy Policy | WMS PEZA',
        navName: 'Privacy Policy',
      },
    },
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: {
      meta: {
        title: 'Page not found | WMS PEZA',
      },
    },
  },
];
